/*
 * Fires `pdp:variant-change` on document whenever the selected PDP variant
 * changes, with the variant from [data-product-json] as `event.detail.variant`.
 *
 * Why: main.build.js handles variant changes internally and exposes no event,
 * and we don't edit the bundle. Options are native inputs and custom
 * dropdowns, so we listen for both `change` and `click` inside the form, let
 * the bundle update [name="id"] first (setTimeout), then emit once per new id.
 *
 * Also defines <variant-sku>, which keeps the SKU text in sync.
 */
(function () {
  'use strict';

  if (window.PdpVariant) return;

  var FORM_SELECTOR = '[data-product-form]';
  var lastVariantId = null;

  function getProduct() {
    var jsonEl = document.querySelector(FORM_SELECTOR + ' [data-product-json]');

    if (!jsonEl) return null;

    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function getCurrentVariant() {
    var product = getProduct();
    var idInput = document.querySelector(FORM_SELECTOR + ' [name="id"]');

    if (!product || !Array.isArray(product.variants) || !idInput) return null;

    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(idInput.value)) {
        return product.variants[i];
      }
    }

    return null;
  }

  function emitIfChanged() {
    var variant = getCurrentVariant();

    if (!variant || variant.id === lastVariantId) return;

    lastVariantId = variant.id;
    document.dispatchEvent(new CustomEvent('pdp:variant-change', { detail: { variant: variant } }));
  }

  function onInteraction(event) {
    if (!event.target.closest || !event.target.closest(FORM_SELECTOR)) return;

    setTimeout(emitIfChanged, 50);
  }

  document.addEventListener('change', onInteraction);
  document.addEventListener('click', onInteraction);

  document.addEventListener('DOMContentLoaded', function () {
    var variant = getCurrentVariant();

    if (variant) lastVariantId = variant.id;
  });

  window.PdpVariant = { getCurrentVariant: getCurrentVariant };

  class VariantSku extends HTMLElement {
    connectedCallback() {
      this.valueElement = this.querySelector('[data-variant-sku-value]');
      this.onVariantChange = this.onVariantChange.bind(this);
      document.addEventListener('pdp:variant-change', this.onVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('pdp:variant-change', this.onVariantChange);
    }

    onVariantChange(event) {
      var sku = event.detail.variant.sku || '';

      if (this.valueElement) this.valueElement.textContent = sku;
      this.hidden = !sku;
    }
  }

  if (!customElements.get('variant-sku')) customElements.define('variant-sku', VariantSku);
})();
